// WooCommerce標準Store APIとの通信を、画面の描画処理から分離する
export function createStoreApi($, config) {
  let nonce = config.nonce;

  // 各応答のnonceを保存し、次の通信へ引き継ぐ
  function sendRequest(route, method = "GET", data = {}) {
    const url = new URL(config.apiRoot, window.location.href);
    if (url.searchParams.has("rest_route")) {
      url.searchParams.set("rest_route", url.searchParams.get("rest_route").replace(/\/$/, "") + "/" + route);
    } else {
      url.pathname = url.pathname.replace(/\/$/, "") + "/" + route;
    }
    const result = $.ajax({
      url: url.toString(), method, dataType: "json", cache: false,
      timeout: method === "GET" ? 15000 : 30000,
      contentType: method === "GET" ? undefined : "application/json",
      data: method === "GET" ? data : JSON.stringify(data),
      headers: { Nonce: nonce },
    });
    result.always(function (_data, _status, xhr) {
      const response = xhr && xhr.getResponseHeader ? xhr : _data;
      if (response && response.getResponseHeader) nonce = response.getResponseHeader("Nonce") || nonce;
    });
    return result;
  }

  // nonceの無効・欠落時だけカートを読み直し、元の操作を1回まで再送する
  function request(route, method = "GET", data = {}) {
    const result = $.Deferred();

    function send(canRetry) {
      sendRequest(route, method, data).done(function () {
        result.resolveWith(this, arguments);
      }).fail(function (xhr) {
        const code = xhr.responseJSON?.code;
        const nonceError = [401, 403].includes(xhr.status)
          && ["woocommerce_rest_invalid_nonce", "woocommerce_rest_missing_nonce"].includes(code);
        if (!canRetry || method === "GET" || !nonceError) {
          result.rejectWith(this, arguments);
          return;
        }

        sendRequest("cart").done(function () {
          send(false);
        }).fail(function () {
          result.rejectWith(this, arguments);
        });
      });
    }

    send(true);
    return result.promise();
  }

  return {
    products: (page) => request("products", "GET", { page, per_page: 12, order: "asc", orderby: "menu_order", catalog_visibility: "catalog" }),
    product: (id) => request("products/" + id),
    variations: (id) => request("products", "GET", { type: "variation", parent: id, per_page: 100 }),
    cart: () => request("cart"),
    add: (id, quantity) => request("cart/add-item", "POST", { id, quantity }),
    update: (key, quantity) => request("cart/update-item", "POST", { key, quantity }),
    remove: (key) => request("cart/remove-item", "POST", { key }),
    // 注文確定は、応答不明時の二重送信を避けるため自動再送しない。
    checkout: (data) => sendRequest("checkout", "POST", data),
  };
}
